var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accept-container"},[_c('iframe',{ref:"mainIframe",staticStyle:{"width":"100%","height":"600px"},attrs:{"id":"mainIframe","name":"mainIframe","frameborder":"0","src":_vm.linkpage}})])}
var staticRenderFns = []

export { render, staticRenderFns }